import { Tag, Alert, Space } from 'antd';
import { humaniseEnum } from '../studioConstants';

// ─────────────────────────────────────────────────────────────────
// Product Creation Studio — right-side summary card.
//
// Snapshot of the most important fields as the user moves through the
// wizard. Updates live from the parent's Form values. Never editable.
// ─────────────────────────────────────────────────────────────────

function YesNo({ value }) {
  if (value === true)  return <Tag color="blue">Yes</Tag>;
  if (value === false) return <Tag>No</Tag>;
  return <span style={{ color: '#94A3B8' }}>—</span>;
}

export default function ProductStudioSummary({
  values, enabledSections, imageCount, warnings, mode, itemId
}) {
  const safe = values || {};
  return (
    <div className="erp-studio-summary" aria-label="Item summary">
      <h2>Summary</h2>

      <dl>
        <dt>Name</dt>
        <dd>{safe.itemName || <span style={{ color: '#94A3B8' }}>—</span>}</dd>

        <dt>Code</dt>
        <dd>{safe.itemCode || <span style={{ color: '#94A3B8' }}>—</span>}</dd>

        <dt>Type</dt>
        <dd>{humaniseEnum(safe.itemType) || <span style={{ color: '#94A3B8' }}>—</span>}</dd>

        <dt>HSN/SAC</dt>
        <dd>{safe.hsncode || <span style={{ color: '#94A3B8' }}>—</span>}</dd>

        <dt>GST %</dt>
        <dd>{(safe.gstRatePercent || safe.gstRatePercent === 0)
          ? Number(safe.gstRatePercent).toFixed(2)
          : <span style={{ color: '#94A3B8' }}>—</span>}</dd>

        <dt>Taxability</dt>
        <dd>{humaniseEnum(safe.taxabilityType) || <span style={{ color: '#94A3B8' }}>—</span>}</dd>

        <dt>Goods</dt>
        <dd><YesNo value={safe.isGoods} /></dd>

        <dt>Service</dt>
        <dd><YesNo value={safe.isService} /></dd>

        <dt>Stock</dt>
        <dd><YesNo value={safe.isStockItem} /></dd>

        <dt>Sellable</dt>
        <dd><YesNo value={safe.isSellable} /></dd>

        <dt>Purchasable</dt>
        <dd><YesNo value={safe.isPurchasable} /></dd>

        <dt>Status</dt>
        <dd>{humaniseEnum(safe.status) || <span style={{ color: '#94A3B8' }}>—</span>}</dd>
      </dl>

      <div style={{ marginTop: 12, borderTop: '1px dashed #E2E8F0', paddingTop: 10 }}>
        <h2>Sections</h2>
        <Space wrap size={[6, 6]}>
          {enabledSections && enabledSections.glass    ? <Tag color="processing">Glass</Tag>    : null}
          {enabledSections && enabledSections.profile  ? <Tag color="processing">Profile</Tag>  : null}
          {enabledSections && enabledSections.hardware ? <Tag color="processing">Hardware</Tag> : null}
          {enabledSections && enabledSections.jobwork  ? <Tag color="processing">Jobwork</Tag>  : null}
          {enabledSections && enabledSections.ecommerce ? <Tag color="purple">Ecommerce</Tag>   : null}
          {(typeof imageCount === 'number' && imageCount > 0)
            ? <Tag color="gold">{imageCount} image{imageCount === 1 ? '' : 's'}</Tag>
            : null}
        </Space>
      </div>

      {Array.isArray(warnings) && warnings.length > 0 ? (
        <div style={{ marginTop: 12 }}>
          <Alert
            type="warning"
            showIcon
            message={`${warnings.length} validation issue${warnings.length === 1 ? '' : 's'}`}
            description={
              <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12 }}>
                {warnings.slice(0, 6).map((w, i) => <li key={i}>{w}</li>)}
              </ul>
            }
          />
        </div>
      ) : null}

      <div style={{ marginTop: 12, fontSize: 11.5, color: '#64748B' }}>
        Mode: {mode === 'edit' ? 'Editing existing item' : 'Creating new item'}
        {itemId ? <><br />ID: <span style={{ fontFamily: 'monospace' }}>{itemId.slice(0, 8)}…</span></> : null}
      </div>
    </div>
  );
}
